import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
import NProgress from 'nprogress'
// import $fn from '@/utils/fn';
// import PageApi from '@/apis/pageApi'
import cookies from "@/utils/cookie";


// 初始化下拉列表
const initDetailList = () => {
    window.App.$store.dispatch('user/getPlatform')
    window.App.$store.dispatch('user/getGame')
    window.App.$store.dispatch('user/getGametype')
    window.App.$store.dispatch('user/getServerlist')
    window.App.$store.dispatch('user/getSpacetype')
}

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.publicPath,
    routes,
});

router.afterEach((to, from) => {
    NProgress.done();
    window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
    /* must call `next` */
})

export default router;
